export default __webpack_public_path__ + "static/media/Blanket.cfb2b230.png";